<template>
	<Autoaddress
		licencekey="0D3CA502-2660-C5A2-7450-C369CE48F412"
		vanityMode="true"
		addressProfile="PandaDefault"
		country="ie"
		language="en"
		searchButtonLabel="Check Address"
		@onAddressFound="handleAddressFound($event)"
		nuaAddressFoundLabel="We've found your address but it isn't unique. Please enter/add your Eircode"
		:noEircodeAppendedLabel="null"
	/>
	<transition name="fade">
		<div id="autoaddress_results" class="pt-3" v-if="vanityAddress.length">
			<div class="row">
				<div class="col-12 col-md-6 mb-3 mb-md-0">

					<template v-if="allServicesAvailable || someServicesAvailable">
						<div key="all" v-if="allServicesAvailable">
							<h6 class="mb-1">Amazing!</h6>
							<p class="mt-0">All of our services are available at your address</p>

						</div>
						<div key="nowaste" v-else-if="isWasteServiceable == 'N' && wastePlanPage">
							<h6 class="mb-1">Sorry!</h6>
							<p class="mt-0">We're currently unable to service waste in your area so we can't sign you up
								for
								this plan.<br>We can provide the following services for you:</p>
						</div>
						<div key="nobags" v-else-if="isSkipBagServiceable == 'N' && skipBagPage">
							<h6 class="mb-1">Sorry!</h6>
							<p v-if="isSkipServiceable == 'N'" class="mt-0">We're sorry, the address you have entered is
								not covered for a skip bag collection. You can call our skip
								bag team at <a href="tel:01 773 9997">01 773 9997</a>.
							</p>
							<p v-else>We're currently unable to deliver or collect skip bags in your area, but why not
								order a skip?</p>
						</div>
						<div key="notall" v-else-if="someServicesAvailable">
							<h6 class="mb-1">Great!</h6>
							<p class="mt-0">These services are available at your address</p>
						</div>
						<a v-if="!wastePlanPage && !skipBagPage" href="/panda-home/sign-up" class="fw-bold ">Sign Up
							Today</a>
					</template>
					<template v-else>
						<h6 class="mb-1">Sorry!</h6>
						<p class="mt-0">We don't provide any of our services at your location yet</p>
					</template>
				</div>
				<div class="col-12 col-md-6 fw-bold">

					<div v-if="isWasteServiceable == 'Y'"><i class="fas fa-check color-brand-primary"></i> Domestic
						waste
						solutions
					</div>

					<div v-if="isSkipServiceable == 'Y'"><i class="fas fa-check color-brand-primary"></i> Skips</div>

					<div v-if="isSkipBagServiceable == 'Y'"><i class="fas fa-check color-brand-primary"></i> Skip bags
					</div>

				</div>

			</div>
		</div>
	</transition>
</template>
<script>
/* global wastePlanPage, skipBagPage */
import Autoaddress from '@autoaddress.ie/autoaddress-vue/src/Autoaddress';
import axios from 'axios';

export default {
	components: {
		Autoaddress,
	}, data() {
		return {
			vanityAddress: [],
			postcode: '',
			isWasteServiceable: '',
			isGasServiceable: '',
			isElectricityServiceable: '',
			isSkipServiceable: '',
			isSkipBagServiceable: '',
			domesticPriceGroup: '',

		}
	}, computed: {
		wastePlanPage() {
			if (typeof (wastePlanPage) !== 'undefined') {
				return wastePlanPage;
			} else {
				return false;
			}
		}, skipBagPage() {
			if (typeof (skipBagPage) !== 'undefined') {
				return skipBagPage;
			} else {
				return false;
			}
		}, allServicesAvailable() {
			return this.isWasteServiceable == 'Y' && this.isSkipServiceable == 'Y' && this.isSkipBagServiceable == 'Y';
		},
		someServicesAvailable() {
			return this.isWasteServiceable == 'Y' || this.isSkipServiceable == 'Y' || this.isSkipBagServiceable == 'Y';
		}
	}, mounted() {

		for (const property in this.$data) {
			if (sessionStorage.getItem(`${property}`)) {
				let val = property == 'vanityAddress' ? JSON.parse(sessionStorage.getItem(`${property}`)) : sessionStorage.getItem(`${property}`)
				this[`${property}`] = val
			}
		}
		if (sessionStorage.getItem('vanityAddress')) {
			document.querySelector('.autoaddress-text-box').value = JSON.parse(sessionStorage.getItem('vanityAddress')).
				join(', ');
		}
	}, methods: {
		updateResults(data) {
			for (const property in data) {
				/* eslint-disable no-prototype-builtins */
				this.addressFound = true;
				if (this.$data.hasOwnProperty(`${property}`)) {
					this[`${property}`] = data[`${property}`]
				}
				/* eslint-enable no-prototype-builtins */
			}
		}, handlePlanPageResults(data) {
			if (data.isWasteServiceable == 'Y') {
				document.getElementById('addressModalClose').
					classList.
					remove('d-none')
				document.getElementById('addressModalAltLink').
					classList.
					add('d-none')
			} else {
				document.getElementById('addressModalClose').
					classList.
					add('d-none')
				document.getElementById('addressModalAltLink').
					classList.
					remove('d-none')
			}
		}, handleSkipBagPageResults(data) {
			if (data.isSkipBagServiceable == 'Y') {
				console.log('yes');
				document.getElementById('addressModalClose').
					classList.
					remove('d-none')
				document.getElementById('addressModalAltLink').
					classList.
					add('d-none')
				document.getElementById('addressModalSkipsLink').
					classList.
					add('d-none')
			} else if (data.isSkipBagServiceable == 'N' && data.isSkipServiceable == 'Y') {
				console.log('skips');
				document.getElementById('addressModalClose').
					classList.
					add('d-none')
				document.getElementById('addressModalAltLink').
					classList.
					add('d-none')
				document.getElementById('addressModalSkipsLink').
					classList.
					remove('d-none')
			} else {
				console.log('no');
				document.getElementById('addressModalClose').
					classList.
					add('d-none')
				document.getElementById('addressModalAltLink').
					classList.
					remove('d-none')
				document.getElementById('addressModalSkipsLink').
					classList.
					add('d-none')
			}
		}, handleAddressFound(data) {
			if (data.result.code <= 200) {
				if (data.vanityAddress) {
					document.querySelector('.autoaddress-text-box').value = data.vanityAddress;
				}
				this.vanityAddress = data.vanityAddress;
				this.postcode = data.postcode;

				axios.get(`${window.location.origin}/wp-json/wp/v2/AutoAddressGetInfo`,

					{
						params: {
							ecadId: data.addressId,
						},
					}).
					then((response) => {
						// handle success

						this.updateResults(response.data)
						if (this.wastePlanPage) {
							this.handlePlanPageResults(response.data);
						} else if (this.skipBagPage) {
							console.log('bagpage');
							this.handleSkipBagPageResults(response.data);
						}
					}).
					catch(function (error) {
						// handle error
						console.log(error);
					})

			}
		},
	}, watch: {
		vanityAddress(newVal) {
			sessionStorage.setItem('vanityAddress',
				JSON.stringify(newVal));
		}, postcode(newVal) {
			sessionStorage.setItem('postcode',
				newVal);
		}, isWasteServiceable(newVal) {
			sessionStorage.setItem('isWasteServiceable',
				newVal);
		}, isGasServiceable(newVal) {
			sessionStorage.setItem('isGasServiceable',
				newVal);
		}, isElectricityServiceable(newVal) {
			sessionStorage.setItem('isElectricityServiceable',
				newVal);
		}, isSkipServiceable(newVal) {
			sessionStorage.setItem('isSkipServiceable',
				newVal);
		}, isSkipBagServiceable(newVal) {
			sessionStorage.setItem('isSkipBagServiceable',
				newVal);
		}, domesticPriceGroup(newVal) {
			sessionStorage.setItem('domesticPriceGroup',
				newVal);
		},
	},
}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease;
}

.fade-enter-active {
	transition-delay: 0.25s;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
